import { Component } from '@angular/core';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, WebAPIRequest } from '@m4u-angular/base/entities/BaseEntities';
import { WebAPIRequestEndpoint } from '@m4u-angular/core/endpoints/webapi-request.endpoint';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    Body: string;
    Response: string;
    QueryString: string;
    Tabs: any[];
    CurrentTabIndex: number;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-request-history',
    templateUrl: './request-history.component.html',
    styleUrls: ['./request-history.component.scss']
})
export class RequestHistoryComponent extends BasePageCRUDComponent<WebAPIRequest, State, WebAPIRequestEndpoint> {

    constructor(A: ServiceBagService, webAPIRequestEndpoint: WebAPIRequestEndpoint) {
        super(A, 'RequestHistoryComponent', WebAPIRequest, State, webAPIRequestEndpoint, EnumPageDisplayModes.Window);
    }

    override OnEntityLoaded() {
        this.InitBody();
        this.InitResponse();
        this.InitQueryString();
        this.InitTabs();
    }

    public CopyText() {
        navigator.clipboard.writeText(this.State.CurrentTabIndex === 0 ? this.State.Body : this.State.Response);
        this.UI.InfoMessage(this.RC("msgTextCopied"));
    }

    private InitBody() {
        if (this.Entity?.Body) {
            const json = JSON.parse(this.Entity.Body);
            this.State.Body = JSON.stringify(json,undefined, 4);
        }
    }

    private InitResponse() {
        if (this.Entity?.Response) {
            const json = JSON.parse(this.Entity.Response);
            this.State.Response = JSON.stringify(json,undefined, 4);
        }
    }

    private InitQueryString() {
        if (this.Entity?.QueryString) {
            this.State.QueryString = this.Entity.QueryString;
            if (this.State.QueryString.startsWith('?')) { this.State.QueryString = this.State.QueryString.substring(1); }
            this.State.QueryString = this.State.QueryString.split('&').join('\r\n')
        }
    }

    private InitTabs() {
        this.State.Tabs = [];

        if(this.Entity.Body) {
            this.State.Tabs.push({
                index: 0,
                text: this.RC("lblBody"),
                Name: "Body"
            });
            
            this.State.CurrentTabIndex = 0;
        } else {
            this.State.CurrentTabIndex = 1;
        }
       
        this.State.Tabs.push({
            index: 1,
            text: this.RC("lblResponse"),
            Name: "Response"
        });
    }
}